// extracted by mini-css-extract-plugin
export var errorIcon = "_ni-1";
export var nameLogo = "_ni-0";